<script>
import { mapState } from 'vuex'
import { PreferencesForm } from '@src/forms/Property'
import dropdown from '@src/data/dropdown.json'
import Request from '@src/mixins/request'

export default {
  mixins: [Request],

  props: {
    name: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {},
      dropdown,
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
  },

  mounted() {
    this.form = new PreferencesForm(this.$route.params.property)
  },

  methods: {
    onSubmit() {
      this.updateData({
        url: this.endpoint.property.updatePreferences,
        data: {
          id: this.currentProperty.id,
          update: this.form,
        },
      })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseCard>
      <BaseControlInput label="Time zone">
        <VAutocomplete
          v-model="form.timeZoneId"
          label="Time zone"
          color="gold"
          :items="$route.params.timeZones"
          item-text="name"
          item-value="id"
        />
      </BaseControlInput>

      <BaseControlInput label="Base currency">
        <VAutocomplete
          v-model="$route.params.property.preferences.baseCurrencyId"
          label="Base currency"
          color="gold"
          :items="$route.params.currencies"
          item-text="code"
          item-value="id"
          disabled
        />
      </BaseControlInput>

      <BaseControlInput label="Display currency">
        <VAutocomplete
          v-model="form.displayCurrencyId"
          label="Display currency"
          color="gold"
          :items="$route.params.currencies"
          item-text="code"
          item-value="id"
        />
      </BaseControlInput>

      <BaseControlInput label="Tax">
        <VTextField v-model="form.tax" label="Tax" color="gold" suffix="%" />
      </BaseControlInput>

      <BaseControlInput label="Service">
        <VTextField
          v-model="form.service"
          label="Service"
          color="gold"
          suffix="%"
        />
      </BaseControlInput>

      <BaseControlInput label="Show rate including fees">
        <VAutocomplete
          v-model="form.showFees"
          label="Show rate including fees"
          color="gold"
          :items="dropdown.switch"
        />
      </BaseControlInput>

      <BaseControlInput label="Show property star rate">
        <VAutocomplete
          v-model="form.showStar"
          label="Show property star rate"
          color="gold"
          :items="dropdown.switch"
        />
      </BaseControlInput>

      <BaseControlInput label="Use decimal">
        <VAutocomplete
          v-model="form.useDecimal"
          label="Use decimal"
          color="gold"
          :items="dropdown.switch"
        />
      </BaseControlInput>

      <BaseControlInput label="Google Analytic ID">
        <VTextField
          v-model="form.gaId"
          label="Google Analytic ID"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Facebook Pixel ID">
        <VTextField
          v-model="form.pixelId"
          label="Facebook Pixel ID"
          color="gold"
        />
      </BaseControlInput>

      <VBtn
        slot="card-actions-right"
        color="gold"
        type="submit"
        :loading="loading"
        dark
      >
        Update
      </VBtn>
    </BaseCard>
  </VForm>
</template>
